import { useEffect } from 'react';

const loadImage = (src) =>
  new Promise((resolve) => {
    const loader = new Image();
    loader.onload = resolve;
    loader.src = src;
    // Failsafe
    setTimeout(resolve, 1000);
  });

const useImagesLoaded = (images, callback) => {
  useEffect(() => {
    let mounted = true;
    Promise.all(images.map(loadImage)).then(() => {
      // wait for next animation frame to ensure that
      // framer motion controls are defined in the onImagesLoaded callback
      if (mounted) callback();
    });
    return () => {
      mounted = false;
    };
  }, [images, callback]);
};

export default useImagesLoaded;
